module.exports = __webpack_public_path__ + "static/media/white-substation.edd910b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-substation.svg
// module id = 313
// module chunks = 0